const setLocalStorage = (key: string, value: object | string | number | boolean | null): void => {
    if (typeof window !== 'undefined') {
        window.localStorage.setItem(key, JSON.stringify(value));
    }
};

export { setLocalStorage };
